import { GetStaticPropsContext, InferGetStaticPropsType, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import { useIntl } from 'react-intl';

import { Duration } from 'constants/duration.constants';
import Prefetcher from 'services/prefetcher';

import EventTransferContainer from 'components/@transfer/EventTransferContainer';

const EventTransfer: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = () => {
  const intl = useIntl();

  return (
    <>
      <NextSeo
        title={intl.formatMessage({ id: 'seo.event.transfer.title' })}
        noindex
        nofollow
      />
      <EventTransferContainer />
    </>
  );
};

export default EventTransfer;

export const getStaticProps = async ({
  locale,
  preview,
}: GetStaticPropsContext) => {
  const prefetcher = await Prefetcher.init({ locale, preview });

  return {
    props: {
      dehydratedState: prefetcher.dehydratedState,
    },
    revalidate: Duration.TEN_MIN,
  };
};
